<template>
  <va-edit-layout>
    <medical-insurances-form :id="id" :title="title" :item="item"></medical-insurances-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
